import axios from "axios";
// import qs from 'querystring'
import { getToken,getTenantId } from "../utils/service";
// 获取接口白名单
import { setTenantIdList} from "../api/config";

// import Store from "../store/index";
import { Message } from 'element-ui';
import { signature } from './index'
// import router from '../router/index'
// 设置请求超时的时间
axios.defaults.timeout = 60000;
// 设置访问的域名前缀
// axios.defaults.baseURL = process.env.BASE_API;
axios.defaults.headers['Content-Type']='application/json';

// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    // 设置请求头
    // config.headers = {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // };
    if (getToken()) {
      config.headers.Authorization = getToken();
    }
    if(Number(getTenantId())&&setTenantIdList.includes(config.url)){
      config.data.TenantId=Number(getTenantId())
    }

    // config.data=qs.stringify(config.data)
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.state === "403") {
      Message.closeAll();
      Message({
        message: response.data.message,
        type: 'error',
        duration: 1000
      })
      sessionStorage.clear();
      if (location.href.indexOf('login') > -1) {
        location.assign('/');
      } else {
        location.assign('/login');
      }
      // router.push({path: '/login'})
      // location.reload();
      return false;
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function Get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function Post(url, data = {},headers={}) {
  if (url.indexOf('listUpdateVersion') > -1) {
    url = process.env.NODE_ENV === 'production' ? 'https://xc.api.zoeeasy.com' + url : 'https://ncloud.test.zhuyitech.com:6443' + url
  }
  let timestamp = Math.round(new Date().getTime()/1000);
  headers.headers = {sign: signature(JSON.stringify({timestamp, method: url})), timestamp};
  return new Promise((resolve, reject) => {
    axios.post(url, data,{
      ...headers
    }).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export default axios;
